<app-rback [type]="21" [rsback]="true" theme='i-new'></app-rback>   
<div class="full-map-wrapper">
  <div class="qqmap-wrapper" id="qq-full-map-wrapper"></div>
</div>